module.exports = __webpack_public_path__ + "img/29.3ad43a72.jpg";